import React, { Component } from 'react';
import 'primereact/resources/themes/nova-light/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import tableRequest from '../../models/tableRequest.js';
import { ConfirmationModal } from '../../template/ConfirmationModal';
import CategoryService from '../../services/CategoryService';
import MessageComponent from '../../template/Message';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import Loaders from '../../template/Loaders';
import $ from 'jquery';

// create Category
export default class Category extends Component {
    constructor(props) {
        super(props);
        this.CategoryService = new CategoryService();
        this.tblResponse = new tableRequest();
        this.state = {
            visible: false,
            updateLoader:false,
            sortOrder:'',
            CategoryId: '',
            Name: '',
           // CategoryDDL: [],
            IsActive: false,

            formError: {
               
                 Name : ''
            },

            formHeading: 'Category',
            buttonLabel: 'Submit',
            sales: [],
            loading: true,
            first: 0,
            rows: 5,
            totalRecords: 0,
            globalFilter: null,
            emptyMessage: 'No Data found',
        }

        this.actionTemplate = this.actionTemplate.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.submitForm = this.submitForm.bind(this);
        this.hideFunc = this.hideFunc.bind(this);
        this.onPage = this.onPage.bind(this);
        this.searchFilter = this.searchFilter.bind(this);
        this.openDialog = this.openDialog.bind(this);
        this.onSort = this.onSort.bind(this);
    }

  //trigger api function on page call
    componentDidMount() {
        setTimeout(() => {
            this.GetCategories();
           // this.GetCategoryDDL();
        }, 1000);
        $('.p-column-title').on('click', function(){
            $(this).next().removeClass('pi-sort').toggleClass('pi-sort-up').addClass('pi-sort-down');
        });
    }
    //loading page 
    onPage(event) {
        this.setState({
            loading: true
        });

        //imitate delay of a backend call
        setTimeout(() => {
            this.getLazyLoadingValues(event);
            this.GetCategories();
        }, 250);
    }

    // get list of data
    getLazyLoadingValues(event) {
        this.setState({ rows: event.rows });
        this.tblResponse.PageSize = event.rows;
        this.tblResponse.First = event.first + 1;
        this.tblResponse.IsActive = '%';
        this.tblResponse.SearchValue = event.globalFilter ? event.globalFilter : "";
        // this.tblResponse.SortColumn = event.sortField;
        this.tblResponse.SortOrder = event.sortOrder === 1 ? 'ASC' : 'DESC';
    }

    // get users data list from api
    GetCategories() {
        this.tblResponse.SortColumn = 'CreatedDt';
        this.CategoryService.GetCategories(this.tblResponse).then(data => {
            const resdata = data.data;
            if (resdata !== null && resdata.ResponseData !== null && resdata.ResponseData.length > 0) {
                this.datasource = resdata.ResponseData;
              //when response data is not null
                this.setState({
                    totalRecords: resdata.ResponseData[0].TotalRows,
                    first: (this.tblResponse.First - 1),
                    sales: this.datasource.slice(0, ((this.tblResponse.First - 1) + this.tblResponse.PageSize)),
                    loading: false,
                    updateLoader:true
                });
            }
            // when responsedata is null
             else {
                this.datasource = null;
                this.setState({
                    totalRecords: 0,
                    first: 1,
                    sales: null,
                    loading: false,
                    updateLoader:true

                });
            }
        });
    }

   
  /// validate form
    validateForm(value, name) {
        let errors = this.state.formError;
        let IsValid = true;
    //this switch case is used for each form field to validate
        switch (name) {
            // case 'CategoryId':
            //     if (value.length < 1) {
            //         IsValid = false;
            //         errors.CategoryId = "Please select category.";
            //     } else errors.CategoryId = ''
            //     break;
            case 'Name':
                if (value.length < 1) {
                    IsValid = false;
                    errors.Name = "Please enter category.";
                } else errors.Name = ''
                break;

            default:
                break;
        }

        return IsValid;
    }

    // call every change of form and validation part also
    handleChange(event) {
        const { name, value } = event.target;
        let errors = this.state.formError;

        const isValid = this.validateForm(value, name);
        this.setState({ errors, [name]: value });
      //this statement will set state value for IsActive
        if(name == "IsActive")
        this.setState( {
            IsActive: event.target.checked
        });
    }

    // Open Dialog
    openDialog() {
        this.setState({ visible: true });
        this.formReset();
    }
    // reset form text value
    formReset() {
        this.setState({
            
            CategoryId: '',
            Name: '',
            IsActive: true,
            formError: {
                
                Name: ''
            }
        });
        let errors = this.state.formError;
        Object.entries(errors).map(([key, value]) => {
            errors[key] = '';
        });
    }
    // Hide Func
    hideFunc() {
        this.setState({
            visible: false, buttonLabel: 'Submit',
            formHeading: 'Add Category'
        })
        this.formReset();
    }
    // submit form and create or update user
    submitForm(event) {
        event.preventDefault();

        let isfrmvalid = true;
        let checkerror = this.state.formError;

        Object.entries(checkerror).map(([key, value]) => {
            const val = this.state[key]
            let valid = this.validateForm(val, key);
            //when form validation is not valid
            if (!valid) {
                this.setState({ checkerror: isfrmvalid });
                isfrmvalid = false;
            }
        });

      //when isfrmvalid is true
        if (isfrmvalid) {
            debugger
            this.setState({updateLoader:false})
            const formData = {
                CategoryId: this.state.CategoryId === '' ? 0 : parseInt(this.state.CategoryId),
                Name: this.state.Name,
                IsActive : this.state.IsActive

            }

            setTimeout(() => {
                this.CategoryService.CreateUpdateCategory(formData).then(data => {
                    const resdata = data.data;
               //when data is not null it will give success message else will move to 'else statement'
                    if (resdata !== null && resdata.ResponseCode === '200') {
                        this.refs.Messchild.showSuccess(resdata.ResponseMessage);
                        this.GetCategories();
                        this.setState({
                            loading: true,
                            visible: false,
                            updateLoader:true
                        });
                        this.formReset();

                       
                    } else if (resdata.ResponseCode === '400') {
                        this.refs.Messchild.showWarn(resdata.ResponseMessage);
                        this.setState({
                            
                            updateLoader:true
                        });
                    } else {
                        this.refs.Messchild.showError(resdata.ResponseMessage);
                        this.setState({
                            
                            updateLoader:true
                        });
                    }
                });
            }, 1000);
        }
    }

    // delete user data
    // deleteSubCategory(subCategoryId) {
    //     setTimeout(() => {
    //         this.CategoryService.DeleteSubCategory(subCategoryId).then(data => {
    //             const resdata = data.data;
    //             if (resdata !== null && resdata.ResponseCode === '200') {
    //                 this.refs.Messchild.showSuccess(resdata.ResponseMessage);
    //                 const totlrecord = this.state.totalRecords - 1;
    //                 const row = this.state.rows;

    //                 if (this.tblResponse.First >= totlrecord) {
    //                     const _curntCursor = Math.round(totlrecord / row);
    //                     this.tblResponse.First = _curntCursor + 1;
    //                 }
    //                 this.GetSubCategories();
    //             } else {
    //                 this.refs.Messchild.showError(resdata.ResponseMessage);
    //             }
    //         });
    //     }, 1000);
    // }

    // Search Filter data
    searchFilter(e) {
        this.setState({
            loading: true
        });
        this.tblResponse.SearchValue = e.target.value;
        this.GetCategories();
    }
 
    // message
    callbackFunction = (childData) => {
        this.setState({ message: childData })
    }

    // disabled Checkbox
    activeTemplate(rowData, column) {
        return (
            <input type="checkbox" disabled checked={rowData.IsActive} />
        )
    }
    // edit form 
    actionTemplate(rowData, column) {
        const editMode = (e) => {
            this.setState({
                buttonLabel: 'Update',
                formHeading: 'Update Category',
                visible: true,
                CategoryId: rowData.CategoryId.toString(),
                Name: rowData.Name,
                IsActive: rowData.IsActive

            });

           // let checkbox = document.getElementsByName('IsActive');
            
            //checkbox[0].checked = rowData.IsActive;
        }

        const deleteFunc = () => {
            // this.refs.child.confirmModal();
            // if (this.refs.child.state.confirm == true) {
            //     this.deleteSubCategory(rowData.SubCategoryId);
            // } else {
            // }
            confirmAlert({
                title: 'Confirm to delete',
                message: 'Are you sure to do this.',
                buttons: [
                    {
                        label: 'Yes',
                        onClick: () => this.deleteSubCategory(rowData.SubCategoryId)
                    },
                    {
                        label: 'No',
                        onClick: () => null
                    }
                ]
            });
        }

        return <span>
            <Button type="button" icon="pi pi-pencil" onClick={editMode} className="p-button-warning" style={{ marginRight: '3px' }}></Button>
            {/* <Button type="button" icon="pi pi-trash" onClick={deleteFunc} className="p-button-danger"></Button> */}
        </span>;
    }

    // sort list
    onSort(event) {
        this.setState({ sortOrder: this.state.sortOrder === 1 ? 2 : 1 });
        const sortField = event.sortField == "CreatedDt" ? "CreatedDt" : event.sortField;
        this.tblResponse.SortColumn = sortField ? sortField : "";
        this.tblResponse.SortOrder = this.state.sortOrder === 1 ? 'DESC' : 'ASC';
        this.GetCategories();
    }

    // create html part
    render() {
        let header = (
            <div style={{ 'textAlign': 'right' }}>
                <i className="pi pi-search" style={{ margin: '4px 4px 0 0' }}></i>
                <InputText type="search" onInput={this.searchFilter} placeholder="Global Search" size="30" />
            </div>
        );

        // const categoryOption = this.state.CategoryDDL.map((category) =>
        //     <option value={category.value} >{category.label}</option>
        // );

        return (
            <>
                <MessageComponent ref="Messchild" />
                <Loaders loader={this.state.updateLoader} />
                <ConfirmationModal parentCallback={this.callbackFunction} ref="child" />
                <div className="heading">
                    <h1>Category</h1>
                    <Button label="Add Category" icon="pi pi-plus-circle" onClick={this.openDialog} />
                </div>

                <DataTable responsive={true} header={header} globalFilter={this.state.globalFilter}
                    emptyMessage={this.state.emptyMessage} value={this.state.sales} sortMode="multiple" paginator={true}
                    rows={this.state.rows} rowsPerPageOptions={[5, 10, 20]} totalRecords={this.state.totalRecords} lazy={true} first={this.state.first}
                    onPage={this.onPage} onSort={this.onSort}>
                    <Column field="Name" header="Category Name" sortable={true} />
                    <Column field="CreatedDate" header="Created Date" sortable={true} />
                    <Column body={this.activeTemplate} header="Status" />
                    <Column body={this.actionTemplate} header="Action" className="custom-center" />
                </DataTable>

                <Dialog header={this.state.formHeading} className="popup-modal" visible={this.state.visible} modal={true} onHide={this.hideFunc}>
                    <form onSubmit={this.submitForm}>
                        <div className="row">
                            
                            <div className="col-md-4 text-right">
                                <label>Category<span>*</span>:</label>
                            </div>
                            <div className="col-md-8 mb-2">
                                <input type="text" value={this.state.Name} onChange={this.handleChange} className="form-control" name="Name" />
                                {this.state.formError.Name !== '' ?
                                    <div className='error'>{this.state.formError.Name}</div> : ''}
                            </div>
                            <div className="col-md-4 text-right">
                                <label>IsActive :</label>
                            </div>
                            <div className="col-md-8 mb-2">
                                <input type="checkbox" checked={this.state.IsActive} className="ml-2" name="IsActive" onChange={this.handleChange} />
                            </div>
                            <div className="col-md-12 text-center">
                                <button type="submit" className="btn btn-primary">{this.state.buttonLabel}</button>
                            </div>
                        </div>
                        <div  >
                            <label>Note: Fields marked as (<span style={{ color: 'red' }}>*</span>) are required</label>
                        </div>
                    </form>
                </Dialog>
            </>
        )
    }
}